import BlogMain from "../components/blog/blog-main";
import BlogPosts from "../components/blog/blog-posts";

function Blog() {
    return ( 
        <>
            <BlogMain />
            <BlogPosts />
        </>
     );
}

export default Blog;